<template>
  <w-dialog @close="cancel"
            :title="tab === 'batch' ? '批量分配到' : '分配到'" v-show="dialogFormVisible"
            :wallStyle="{ zIndex: 2001 }"
            :box-style="{ width: '838px', zIndex: 2001 }"
            :bodyStyle="{ padding: 0 }"
            :footerStyle="{
        borderTop: '1px solid #DEDFE0'
      }">
    <template>
      <div style="display: flex!important;border-bottom: 1px solid #DEDFE0">
        <div style="font-size: 14px;font-weight: 600;line-height: 22px;padding: 13px 0 13px 20px; flex: 1">按组织分配</div>
        <w-input
          size="small"
          style="width: 220px;line-height: 47px;padding-right: 20px"
          clearable
          placeholder='输入姓名或账号搜索'
          v-model="fullName"
          @keyup.enter.native="handlerSearchName">
          <i
            slot="prefix"
            class="w__input__icon r2-icon-action_search"
            style="line-height: 48px;font-size: 16px !important"></i>
          <i
            v-if="fullName !== ''"
            class="r2-icon-nav_cancel cursor-pointer"
            style="line-height: 48px;padding-right: 17px"
            slot="suffix"
            @click="fullName = '';handlerSearchName();">
          </i>
        </w-input>
      </div>
    </template>
    <div class="cfmcc-apply__body-left-dialog">
      <div class="cfmcc-project__left ">
        <w-scrollbar class="cfmcc-project__left_padding" style="height: 404px;" wrap-style="overflow-x: hidden;">
          <div class="height-full" style="padding: 6px 12px;">
            <w-tree :data="groupData"
                    ref="tree"
                    :props="defaultProps"
                    :highlight-current="true"
                    :expand-on-click-node="false"
                    default-expand-all
                    :indent="12"
                    icon-class="r2-icon-nav_chevron_right"
                    node-key="id">
              <div class="custom-tree-node" slot-scope="{ node, data }" :style="{paddingLeft: data.isProject ? '2px' : 0, lineHeight: '32px'}">
                <div class="flex item-container" @click.stop="clickGroupNode(data)" style="width: 166px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        <span class="organizationTitle cfcc-tree-namee__width ellipsis-1"
                              :title="node.label.length > 8 ? node.label : ''">
                            <!-- <i class="r2-icon-nav_chevron_right" v-if="data.subList.length"></i> -->
                          {{ node.label }}
                        </span>
                </div>
              </div>
            </w-tree>
          </div>
        </w-scrollbar>
      </div>
      <div class="cfmcc-project__center" v-loading="loading">
        <div style="height: 22px;padding-bottom: 12px;padding-right: 12px;" v-if="tab === 'batch'">
          <w-checkbox :disabled="treeCheckedId === '' || (this.approval.filter(item => item.gldUserId).length === this.assetDetailsParams.filter(item => item.assetNum).length)"
                      :indeterminate="indeterminate"
                      v-model="checkoutAll"
                      @change="handleCheckoutAllChange">
            全选
          </w-checkbox>
          <span class="float_right font-12">
                当前{{employeeList.length}}/共{{total}}
              </span>
        </div>
        <w-scrollbar :style="{height: ((total < pageSize ? 402 : 366) - (tab === 'batch' ? 34 : 0)) + 'px'}" wrap-style="overflow-x: hidden;">
          <template v-if="tab === 'batch'">
            <div class="w__checkbox-group" v-for="(employee, index) in employeeList" :key="employee.gldUserId">
              <div :class="{'is-checked': employee.gldUserId, 'is-disabled': employee.disabled}"
                   class="w__checkbox block"
                   @click="handleCheckedEmployeesChange(employee)"
                   :style="{marginTop: index === 0 ? 0 : '12px', width: '100%', marginRight: '0px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}">
                    <span class="w__checkbox__input" :class="{'is-checked': employee.checked, 'is-disabled': employee.disabled}">
                        <span class="w__checkbox__inner"></span>
                        <input type="checkbox" class="w__checkbox__original" :value="employee.checked">
                    </span>
                <span class="w__checkbox__label">
                        {{employee.name || employee.account}}
                        <span v-show="searchName">({{employee.departmentName || '集团公司'}})</span>
                    </span>
              </div>
            </div>
          </template>
          <template v-else>
            <div>
              <w-radio-group v-model="radioValue" @change="handleRadioChange">
                <w-radio v-for="(employee, index) in employeeList" :key="employee.gldUserId" :label="employee.gldUserId" :style="{marginTop: index === 0 ? 0 : '12px', width: '100%', marginRight: '0px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}">
                  {{employee.name||employee.account}}
                  <span v-show="searchName">({{employee.departmentName || '集团公司'}})</span>
                </w-radio>
              </w-radio-group>
            </div>
          </template>
        </w-scrollbar>
        <div class="border-box text-align-right" style="height: 36px; padding: 6px 0;">
          <w-pagination
            small
            background
            hide-on-single-page
            @current-change="handleCurrentChange"
            :pager-count="3"
            :current-page.sync="pageNum"
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="total">
          </w-pagination>
        </div>
      </div>
      <div class="cfmcc-project__right">
        <div class="cfmcc-approval__header flex">
          <div class="cfmcc-approval__checked flex-1">
            已选择{{approval.length}}个
          </div>
          <div class="cfmcc-approval__action cursor-pointer hover-link" @click="empty">
            清空
          </div>
        </div>
        <div class="cfmcc-approval__body">
          <ul>
            <li class="flex cfmcc-approval__item">
              <div class="cfmcc-approval__name">员工姓名</div>
              <div class="cfmcc-approval__organize flex-1">所属组织</div>
              <div class="cfmcc-approval__action">操作</div>
            </li>
          </ul>
          <w-scrollbar style="height: 330px;" wrap-style="overflow-x: hidden;">
            <ul>
              <li class="flex cfmcc-approval__item" v-for="(item, index) in approval"
                  :key="item.gldUserId">
                <div class="cfmcc-approval__name ellipsis">
                  <el-tooltip>
                    <div slot="content">
                      {{item.name || item.account}}
                    </div>
                    <div class="ellipsis">{{item.name || item.account}}</div>
                  </el-tooltip>
                </div>
                <div class="cfmcc-approval__organize flex-1 ellipsis">{{item.departmentName || '集团公司'}}
                </div>
                <div class="cfmcc-approval__action color-blue cursor-pointer"
                     @click="handleRemoveReviewer(item, index)">
                  移除
                </div>
              </li>
            </ul>
          </w-scrollbar>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <w-button type="primary" @click="handleSubmitReviewer(approval)">确 定</w-button>
      <w-button @click="cancel" style="border: 1px solid rgb(222, 223, 224); color: #1F1F1F;">取 消</w-button>
    </div>
  </w-dialog>
</template>
<script>
import assetList from '@/assets/service/manage'
import _ from 'lodash'
export default {
  name: 'distribution',
  props: {
    assetDetailsParams: {
      type: Array,
      default: () => ([])
    },
    pageSize: {
      type: Number,
      default: 50
    }
  },
  data (){
    return {
      pageNum: 1,
      total: 0,
      groupData: [], // 组织树
      defaultProps: {
        children: 'subList',
        label: 'departmentName'
      },
      currentGroup: {},
      ids: [],
      employeeList: [], // 人员列表
      // 项目下人员
      treeCheckedId: '',
      approval: [], // 选中人员列表
      checkoutAll: false,
      indeterminate: false,
      fullName: '',
      searchName: '',
      dialogFormVisible: false,
      loading: false,
      tab: '',
      radioValue: '',
      item: []
    }
  },
  mounted () {
    // 获取部门分组
    // this.getDepartmentList()
  },
  methods: {
    // 页码更改
    handleCurrentChange (val) {
      this.pageNum = val
      this.getEmployeeList(this.currentGroup)
    },
    // 选中单个人员
    handleRadioChange (value) {
      this.approval = this.employeeList.filter(item => (item.gldUserId === value))
    },
    // 关闭弹框
    cancel (){
      this.dialogFormVisible = false
      this.fullName = ''
      this.searchName = ''
      this.currentGroup = {}
    },
    // 打开弹框
    async show (tab, item, checkbox){
      this.dialogFormVisible = true
      this.pageNum = 1
      // 获取部门分组
      await this.getDepartmentList()
      this.employeeList.forEach(item => {
        item.checked = false
        item.disabled = false
      })
      this.radioValue = ''
      this.approval = []
      this.checkoutAll = false
      this.indeterminate = false
      this.tab = tab
      if (tab === 'one'){
        item = [{gldUserId: item.gldUserId, assetNum: item.assetNum, status: item.status}]
        this.assetDetailsParams = item
      } else {
        let ref = checkbox.map(item => { return {assetNum: item.assetNum, gldUserId: item.gldUserId, status: item.status} })
        this.assetDetailsParams = ref
      }
    },
    // 分配弹框搜索
    handlerSearchName (){
      this.pageNum = 1
      this.getEmployeeList()
    },
    // 清空选中人员
    empty (){
      this.checkoutAll = false
      this.indeterminate = false
      this.approval.forEach(item => {
        item.checked = false
      })
      this.approval = []
      this.employeeList.forEach(item => {
        item.checked = false
        item.disabled = false
      })
      this.radioValue = ''
    },
    // 审批人项目下人员
    handleCheckoutAllChange (val) {
      // 已选择人员的gldUserIds
      let checkedUserIds = this.approval.map(item => item.gldUserId)
      // this.employeeList.forEach(item => {
      for (let i = 0; i < this.assetDetailsParams.length; i++) {

        // 全选
        if (val) {
          if (checkedUserIds.includes(this.employeeList[i].gldUserId)) {
            this.employeeList[i].checked = val
          }
          // 已选择里不存在
          if (!checkedUserIds.includes(this.employeeList[i].gldUserId) && this.approval.length < this.assetDetailsParams.length) {
            this.employeeList[i].checked = val
            this.approval.push(this.employeeList[i])
          }
        } else {
          this.employeeList[i].checked = val
          // 取消全选
          if (checkedUserIds.includes(this.employeeList[i].gldUserId)) {
            for (let j = 0; j < this.approval.length; j++) {
              if (this.approval[j].gldUserId === this.employeeList[i].gldUserId) {
                this.approval.splice(j, 1)
                break
              }
            }
          }
        }
      }
      this.disabledChange()
      // })
      this.indeterminate = false
    },
    // 选择人员，人员列表checkbox发生变化时
    handleCheckedEmployeesChange (employee) {
      console.log(employee, '55555555555555555555555555555555555555')
      if (employee.disabled) {
        return
      }
      // 已选择人员的gldUserIds
      let checkedUserIds = this.approval.map(item => item.gldUserId)
      if (employee.checked) {
        employee.checked = !employee.checked
        // 移除
        for (let i = 0; i < this.approval.length; i++) {
          if (this.approval[i].gldUserId === employee.gldUserId) {
            this.approval.splice(i, 1)
            break
          }
        }
      } else {
        // 新增
        if (!checkedUserIds.includes(employee.gldUserId) && this.approval.length < this.assetDetailsParams.length) {
          employee.checked = !employee.checked
          this.approval.push(employee)
        }
      }
      this.disabledChange()
      // 设置全选按钮状态
      this.calcSelectAllStatus()
    },
    // 选中人员大于选中资产时灰显其它按钮
    disabledChange (){
      if (this.approval.filter(item => item.gldUserId).length === this.assetDetailsParams.filter(item => item.assetNum).length){
        let list = this.employeeList.filter(item => !item.checked)
        this.$nextTick(() => {
          list.forEach(item => {
            item.disabled = true
          })
        })
      } else {
        let list = this.employeeList.filter(item => !item.checked)
        this.$nextTick(() => {
          list.forEach(item => {
            item.disabled = false
          })
        })
      }
    },
    // 删除已选择人员
    handleRemoveReviewer (item, index) {
      this.approval.splice(index, 1)
      for (let i = 0; i < this.employeeList.length; i++) {
        if (this.employeeList[i].gldUserId === item.gldUserId) {
          this.employeeList[i].checked = false
          this.$set(this, 'radioValue', '')
          console.log(this.radioValue, '=============================')
          break
        }
      }
      this.employeeList.forEach(item => {
        item.disabled = false
      })
      // 设置全选按钮状态
      this.calcSelectAllStatus()
    },
    // 计算全选按钮状态
    calcSelectAllStatus () {
      let checkedCount = this.employeeList.filter(item => item.checked).length
      this.checkoutAll = checkedCount === this.employeeList.length
      this.indeterminate = checkedCount > 0 && checkedCount < this.employeeList.length
    },
    // 分组点击事件
    clickGroupNode ({id, departmentId, departmentName, projectId}) {
      this.pageNum = 1
      this.currentGroup = {id, departmentId, departmentName, projectId}
      this.treeCheckedId = id
      this.checkoutAll = false
      this.indeterminate = false
      this.$refs.tree.setCurrentKey(id)
      if (departmentId !== null) {
        this.getEmployeeList({departmentId, projectId})
      }
      if (departmentName === '集团公司') {
        this.getEmployeeList()
      }
    },
    // 获取员工列表
    getEmployeeList: _.debounce(function (condition = {}) {
      const {departmentId = null, projectId} = condition
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        excludeRoleIdMember: true,
        extrasInfo: false,
        delete: 0,
        fuuzzySearch: this.fullName
      }
      let apiName = 'getEmployeeList'
      if (projectId) {
        apiName = 'getEmployeeList'
        params.projectId = projectId
      } else {
        params.departmentId = departmentId
      }
      this.loading = true
      assetList[apiName](params).then(res => {
        this.searchName = this.fullName
        this.loading = false
        if (res.code === 200) {
          const data = res.data || {}
          const items = data.items || []
          this.total = data.total || 0
          this.getIds()
          items.forEach(item => {
            if (this.ids.includes(item.gldUserId)){
              item.checked = true
            } else {
              item.checked = false
            }
            item.disabled = false
            item.radioChecked = false
          })
          this.employeeList = items
          this.disabledChange()
        }
      }).catch(() => {
        this.searchName = this.fullName
        this.loading = false
        this.employeeList = []
      })
    }, 300),
    // 获取选中之后的人员ID
    getIds (){
      this.ids = this.approval.map(item => {
        return item.gldUserId
      })
    },
    // 组织树数据转换，组装唯一值id
    getTreeData (tree) {
      tree.forEach(node => {
        if (node.projectId) {
          node.id = `${node.departmentId}-${node.projectId}`
        } else {
          node.id = node.departmentId
        }
        if (Array.isArray(node.subList) && node.subList.length) {
          this.getTreeData(node.subList)
        } else {
          node.subList = []
        }
      })
    },
    // 获取分组列表
    getDepartmentList () {
      this.groupData = []
      assetList.getDepartmentList().then(res => {
        if (res.code === 200) {
          const groupData = res.data || []
          this.getTreeData(groupData)
          this.groupData = [
            {
              id: -1,
              departmentId: null,
              departmentName: '集团公司',
              subList: groupData
            }
          ]
        } else {
          this.groupData = [
            {
              id: -1,
              departmentId: null,
              departmentName: '集团公司',
              subList: []
            }
          ]
        }
        this.$nextTick(() => {
          this.clickGroupNode({
            id: -1,
            departmentId: null,
            departmentName: '集团公司'
          })
        })
      })
    },
    // 确定分配
    async handleSubmitReviewer (approval) {
      this.dialogFormVisible = false
      this.approval = approval.map(item => { return {createTime: item.createTime, gldUserId: item.gldUserId} })
      const list = approval.map(item => { return {departmentName: item.departmentName, account: item.account} })
      console.log(this.assetDetailsParams, this.approval, list)
      try {
        let res = await assetList.batchAllocation({
          assetDetailsParams: this.assetDetailsParams,
          userDetailsParams: this.approval
        })
        if (res.code === 200){
          const data = res.data
          const start = Date.now()
          if (this.tab === 'one'){
            this.$nextTick(() => {
              this.sentLog(100117091, {message: this.assetDetailsParams[0].assetNum + '-' + list[0].account + '-' + (list[0].departmentName || '集团公司')})
            })
            assetList.addRelationLog({
              area: this.userInStore.area,
              detail: `${list[0].account}-${this.assetDetailsParams[0].assetNum}`,
              operateType: 'ASSET_ALLCATION',
              relType: '',
              showState: 1
            })
          } else {
            // debugger
            this.$nextTick(() => {
              this.sentLog(100117095, {number: data.successNum, duration: ((Date.now() - start) / 1000).toFixed(5)})
              let ref = data.successList.filter(item => item.operation == 1)
              let str = ref.map(item => { return { account: item.account, assetNum: item.assetNum} })
              let arr = ''
              for (let i = 0; i < str.length; i++) {
                arr += str[i].account + '-' + str[i].assetNum + ';'
              }
              assetList.addRelationLog({
                area: this.userInStore.area,
                detail: arr,
                operateType: 'ASSET_ALLCATION_BATCH',
                relType: '',
                showState: 1
              })
            })
          }
          this.$message({
            type: 'success',
            message: `已完成 ${Math.ceil(data.successNum)} 个资产编号的批量分配`
          })
          this.$parent.postAssetList()
        } else {
          this.$message.error('资产分配失败')
          this.$parent.postAssetList()
        }
      } catch (e) {
        this.$message.error('资产分配失败')
        this.$parent.postAssetList()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.cfmcc-apply__body-left-dialog {
  // width: 838px;
  display: flex;
  // justify-content: start;
  align-items: stretch;

  .cfmcc-project__left {
    height: 416px;
    width: 240px;
    border-right: 1px solid #DEDFE0;
    // display: inline-block;
    // float: left;
    overflow: auto;
  }

  .cfmcc-project__center {
    height: 416px;
    width: 240px;
    // margin-left: 50px;
    // display: inline-block;
    border-right: 1px solid #DEDFE0;
    // float: left;
  }

  .cfmcc-project__right {
    width: 360px;
    height: 416px;
    // float: left;
  }
  .cfmcc-project__left {
    width: 240px;
    padding: 6px 0;
    box-sizing: border-box;
  }

  .cfmcc-project__center {
    width: 240px;
    padding: 16px 0 6px 16px;
    box-sizing: border-box;
  }

  .cfmcc-project__right {
    width: 360px;

    .cfmcc-approval__header {
      padding: 0 24px;
      height: 40px;
      border-bottom: 1px solid #DEDFE0;
      box-sizing: border-box;
      line-height: 39px;
      color: #212530;
      font-weight: 700;
    }

    .cfmcc-approval__body {
      padding: 0 24px;
      /*48  32 48 158*/
      .cfmcc-approval__item {
        height: 40px;
        line-height: 40px;

        .cfmcc-approval__name {
          width: 80px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(33, 37, 48, 0.8);
        }

        .cfmcc-approval__action {
          width: 30px;

        }
      }
    }
  }
}
</style>
<style lang="less">
.cfmcc-project__left_padding {
  .w-tree {
    .w-tree-node__content {
      line-height: 32px !important;
      &:hover {
        background-color: #f3f4f7 !important;
        // color: #2079FA  !important;
      }
    }

    .w-tree-node__expand-icon {
      font-size: 16px;
      padding-left: 0;
      padding-right: 0;
    }

    .w-tree-node__expand-icon {
      transform: rotate(0deg);
      color: rgba(31, 31, 31, 0.55);
    }

    .w-tree-node__expand-icon.expanded {
      transform: rotate(90deg);
      color: rgba(31, 31, 31, 0.55);
      font-size: 16px;
    }

    .is-leaf {
      color: transparent;
    }

  }
}
</style>
